// extracted by mini-css-extract-plugin
export default {"browserupgrade":"App__browserupgrade--OV_Ag","app-body":"App__app-body--P19Is","appBody":"App__app-body--P19Is"};